import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Trans, useTranslation } from 'react-i18next'
import canineI from './artwork/canine-I.png'
import canineII from './artwork/canine-II.png'
import canineIII from './artwork/canine-III.png'
import molarI from './artwork/molar-I.png'
import molarII from './artwork/molar-II.png'
import molarIII from './artwork/molar-III.png'

const useStyles = makeStyles({
  table: {
    borderCollapse: 'collapse',
    fontFamily: 'Dazzed, sans-serif',
    '& th': { whiteSpace: 'nowrap', fontSize: 14 },
    width: '100%',
    fontSize: 12,
    lineHeight: 1.4,
    '& th, & td': { padding: 8, borderBottom: '1px solid #F0F0F3', verticalAlign: 'middle' },
    '& tr > :not(:first-child)': { borderLeft: '1px solid #F0F0F3' },
    '& tbody tr:last-child > *': { borderBottom: 'none' },
    '@media (max-width: 600px)': { '& th, & td': { padding: 6 } }
  },
  description: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    '@media (max-width: 600px)': { flexDirection: 'column' }
  },
  diagram: {
    width: 72,
    height: 90,
    objectFit: 'contain',
    flexShrink: 0
  }
})

const artwork = {
  canine: { I: canineI, II: canineII, III: canineIII },
  molar: { I: molarI, II: molarII, III: molarIII }
}

const BiteClassificationExplanation = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <table className={classes.table}>
      <thead>
        <tr>
          <th />
          <th>{t('biteClassification.canine')}</th>
          <th>{t('biteClassification.molar')}</th>
        </tr>
      </thead>
      <tbody>
        {['I', 'II', 'III'].map(biteClass => (
          <tr key={biteClass}>
            <th scope="row">{t(`biteClassification.values.${biteClass}`)}</th>
            {['canine', 'molar'].map(type => (
              <td key={type}>
                <div className={classes.description}>
                  <img className={classes.diagram} src={artwork[type][biteClass]} alt="" />
                  <span>
                    <Trans
                      i18nKey={`biteClassification.explanations.${type}.${biteClass}`}
                      components={{ strong: <strong /> }}
                    />
                  </span>
                </div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default BiteClassificationExplanation
